<template>
  <div class="timer">
    <div v-if="!finish_timer">
      <span class="timer-text"> Получить новый код можно </span>

      <span class="time">
        <span class="seconds"> через {{ seconds }}</span> сек
      </span>
    </div>

    <ButtonLink v-else text="Получить новый код" :callback="startTimer" />
  </div>
</template>

<script>
import ButtonLink from '../Login/ButtonLink.vue';

export default {
  props: ['callback'],
  components: { ButtonLink },

  data() {
    return {
      finish_timer: false,
      seconds: 35,
      interval: null,
    };
  },

  methods: {
    startTimer(repeat = true) {
      if (repeat) {
        if (typeof this.callback === 'function') this.callback();
        this.seconds = 35;
        this.finish_timer = false;
      }

      if (this.interval) clearInterval(this.interval);

      this.interval = setInterval(() => {
        this.seconds--;

        if (this.seconds <= 0) {
          clearInterval(this.interval);
          this.interval = null;
          this.finish_timer = true;
        }
      }, 1000);
    },
  },

  beforeMount() {
    this.startTimer(false);
  },

  beforeDestroy() {
    if (this.interval) clearInterval(this.interval);
  },
};
</script>
<style scoped>
.timer {
  font-family: 'Manrope', sans-serif;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.4;
  color: #4B5563;
  text-align: center;
}

.timer-text {
  display: block;
}

.time {
  display: block;
  margin-top: 4px;
  font-size: 16px;
  font-weight: 600;
  color: #2B2D33;
}
</style>
